@switch (fieldType()) {
  @case (inputTypesEnum.TEXT_INPUT_FIELD) {
    <div [formGroup]="previewForm">
      <lib-textarea
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [label]="fieldLabel()"
        [required]="isRequired()"
        [placeholder]="placeholder() || ''" />
    </div>
  }
  @case (inputTypesEnum.SHORT_TEXT_FIELD) {
    <div [formGroup]="previewForm">
      <lib-input
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [label]="fieldLabel()"
        [type]="'text'"
        [required]="isRequired()"
        [placeholder]="placeholder() || ''" />
    </div>
  }
  @case (inputTypesEnum.NUMBER_INPUT_FIELD) {
    <div [formGroup]="previewForm">
      <lib-input
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [label]="fieldLabel()"
        [type]="'number'"
        [required]="isRequired()"
        [placeholder]="placeholder() || ''" />
    </div>
  }
  @case (inputTypesEnum.DROP_DOWN_MENU) {
    <div [formGroup]="previewForm">
      <lib-select
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [label]="fieldLabel()"
        [options]="mappedOptions()"
        [selectedKeyName]="'label'"
        [selectedKeyValue]="'value'"
        [required]="isRequired()"
        [placeholder]="placeholder() || ''" />
    </div>
  }
  @case (inputTypesEnum.CHECK_BOX) {
    <lib-checkbox
      [formGroup]="previewForm"
      [inputFormControlName]="'value'"
      [id]="'preview'"
      [label]="fieldLabel()"
      [options]="mappedOptions()"
      [singleCheckBox]="false"
      [required]="isRequired()" />
  }
  @case (inputTypesEnum.SINGLE_CHECK_BOX) {
    <lib-checkbox
      [formGroup]="previewForm"
      [inputFormControlName]="'value'"
      [id]="'preview'"
      [label]="fieldLabel()"
      [options]="[]"
      [singleCheckBox]="true"
      [required]="isRequired()" />
  }
  @case (inputTypesEnum.RADIO_BUTTON) {
    <lib-radio-button
      [formGroup]="previewForm"
      [inputFormControlName]="'value'"
      [id]="'preview'"
      [label]="fieldLabel()"
      [options]="mappedOptions()"
      [required]="isRequired()" />
  }
  @case (inputTypesEnum.DATE_PICKER) {
    <div [formGroup]="previewForm">
      <lib-date-picker
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [label]="fieldLabel()"
        [required]="isRequired()"
        [placeholder]="placeholder() || ''" />
    </div>
  }
  @case (inputTypesEnum.DATE_TIME_PICKER) {
    <div [formGroup]="previewForm">
      <lib-date-picker
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [label]="fieldLabel()"
        [required]="isRequired()"
        [showTime]="true"
        [placeholder]="placeholder() || ''" />
    </div>
  }
  @case (inputTypesEnum.MONEY) {
    <div [formGroup]="previewForm">
      <lib-money-input
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [label]="fieldLabel()"
        [required]="isRequired()"
        [placeholder]="placeholder() || ''" />
    </div>
  }
  @case (inputTypesEnum.PHONE_NUMBER) {
    <div [formGroup]="previewForm">
      <lib-mobile-input
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [label]="fieldLabel()"
        [required]="isRequired()" />
    </div>
  }
  @case (inputTypesEnum.DUAL_LANGUAGE_TEXT_INPUT_FIELD) {
    <div [formGroup]="dualLangPreviewForm">
      <div formGroupName="label">
        <lib-dual-lang-input
          [inputFormControlName]="'label'"
          [id]="'preview'"
          [name]="'preview'"
          [type]="'text'"
          [label]="fieldLabel()" />
      </div>
    </div>
  }
  @case (inputTypesEnum.DUAL_LANGUAGE_TEXT_AREA_FIELD) {
    <div [formGroup]="dualLangPreviewForm">
      <div formGroupName="label">
        <lib-dual-lang-text-area
          [inputFormControlName]="'label'"
          [id]="'preview'"
          [name]="'preview'"
          [label]="fieldLabel()" />
      </div>
    </div>
  }
  @case (inputTypesEnum.TOGGLE_INPUT_FIELD) {
    <p class="mb-1 text-sm font-medium text-neutral-700">
      {{ fieldLabel() }}
      @if (isRequired()) {
        <span class="text-destructive-500">*</span>
      }
    </p>
    <label
      class="inline-flex cursor-pointer items-center gap-2"
      [attr.aria-label]="fieldLabel()">
      <input type="checkbox" class="sr-only peer" />
      <div
        class="relative h-5 w-9 rounded-full border border-neutral-300 bg-neutral-200 transition-colors peer-checked:border-primary-500 peer-checked:bg-primary-500">
        <div
          class="absolute start-0.5 top-0.5 h-4 w-4 rounded-full bg-white shadow transition-all peer-checked:translate-x-4"></div>
      </div>
    </label>
  }
  @case (inputTypesEnum.MEDIA) {
    <div [formGroup]="previewForm">
      <lib-upload-files
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [uploadUrl]="''"
        [removeUrl]="''"
        [label]="fieldLabel()"
        [required]="isRequired()"
        [disabled]="false" />
    </div>
  }
  @case (inputTypesEnum.LOOKUP) {
    <div [formGroup]="previewForm">
      <lib-lookup-field
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [label]="fieldLabel()"
        [required]="isRequired()"
        [placeholder]="placeholder() || ''"
        [labelValueAssignList]="lookupPreviewAssignList" />
    </div>
  }
  @case (inputTypesEnum.LOOKUP_USER) {
    <div [formGroup]="previewForm">
      <lib-lookup-field
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [label]="fieldLabel()"
        [required]="isRequired()"
        [placeholder]="placeholder() || ''"
        [labelValueAssignList]="lookupPreviewAssignList" />
    </div>
  }
  @default {
    <div [formGroup]="previewForm">
      <lib-input
        [inputFormControlName]="'value'"
        [id]="'preview'"
        [name]="'preview'"
        [label]="fieldLabel()"
        [type]="'text'"
        [required]="isRequired()"
        [placeholder]="placeholder() || ''" />
    </div>
  }
}

@if (hint()) {
  <p class="mt-1 text-xs text-neutral-400">{{ hint() }}</p>
}
